export const getSmsCode = {
    path: "/login/getSmsCode",
    method: "post"
}
export const loginByPhone = {
    path: "/login/loginByPhone",
    method: "post"
}
// 账号密码登录
export const loginByAccount = {
    path: "/login/loginByAccount",
    method: "post"
}
// 刷新令牌
export const refreshToken = {
    path: "/login/refreshToken",
    method: "post"
}
// 订单
// localhost:18081/xdk/?page=1&size=1
export const getUserCardOrder = {
    path: "/userCardOrder/getUserCardOrder",
    method: "get"
}
// 获取用户信息
export const getUserInfo = {
    path: "/userProfileInfo/getUserInfo",
    method: "POST"
}
export const getVipExpiresDate = {
    path: "/userMemberStatus/getVipExpiresDate",
    method: "POST"
}
export const bindMobile = {
    path: "/login/bindMobile",
    method: "POST"
}

// 安全验证
export const getAuthImg = {
    path: "/piccode/getPicCode",
    method: "POST"
}

export const getAuthCode = {
    path: "/piccode/checkClient",
    method: "POST"
}

// 微信授权
export const wechatAuth = {
    path: "/login/getWechatInfo",
    method: "POST"
}
// 微信授权登录
export const wechatLogin = {
    path: "/login/loginByWechat",
    method: "POST"
}
// export const getRealData={
//     path:"/business/getRealData",
//     method:"post"
// }
// 获取会员模板
export const getCardModel = {
    path: "/cardDefinition/getCardModel",
    method: "POST"
}
// 生成订单
export const buyCard = {
    path: "/userCardOrder/buyCard",
    method: "POST"
}
// 支付订单
export const toPayCardOrder = {
    path: "/pay/toPayCardOrder",
    method: "POST"
}
// 修改密码
export const forgetPassword = {
    path: "/login/forgetPassword",
    method: "POST"
}
export const upload = {
    path: "/common/upload",
    method: "POST"
}
export const updateUserProfileInfo = {
    path: "/userProfileInfo/updateUserProfileInfo",
    method: "POST"
}

// 推荐中心/推荐会员的统计数据
export const getStatisticalData = {
    path: "/referrer/index",
    method: "GET"
}
// 推荐中心/推荐会员的列表
export const getRecommendationList = {
    path: "/referrer/list",
    method: "GET"
}
// 推荐中心/推荐会员的曲线
export const getRecommendationCurve = {
    path: "/referrer/line",
    method: "GET"
}

// 佣金流水/统计
export const getPaidStatistics = {
    path: "/paid/index",
    method: "GET"
}
// 佣金流水/记录
export const getPaidList = {
    path: "/paid/list",
    method: "GET"
}

// 提现申请/列表
export const getWithdrawList = {
    path: "/withdraw/list",
    method: "GET"
}
// 提现申请/申请
export const addWithdraw = {
    path: "/withdraw/add",
    method: "POST"
}
// 提现申请/作废
export const deleteWithdraw = {
    path: "/withdraw/edit",
    method: "POST"
}

// 收款渠道/列表
export const getPaidChannelList = {
    path: "/paidChannel/list",
    method: "GET"
}
// 收款渠道/添加
export const addPaidChannel = {
    path: "/paidChannel/add",
    method: "POST"
}
// 收款渠道/修改
export const updatePaidChannel = {
    path: "/paidChannel/edit",
    method: "POST"
}
// 收款渠道/删除
export const deletePaidChannel = {
    path: "/paidChannel/delete",
    method: "GET"
}

/**
 * 获取算力点套餐
 */
export const getComputeRecharge = {
    path: "/cardDefinition/getScoreModel",
    method: "POST"
}
/**
 * 生成算力点订单
 */
export const createComputeRechargeOrder = {
    path: "/userScoreOrder/buyScore",
    method: "POST"
}
/**
 * 支付算力点订单
 */
export const payComputeRechargeOrder = {
    path: "/pay/toPayScoreOrder",
    method: "POST"
}
/**
 * 算力点订单列表
 */
export const getComputeRechargeOrderList = {
    path: "/userScoreOrder/getUserScoreOrder",
    method: "GET"
}

/**
 * AI会话列表/历史记录
 */
export const getAiSessionHistory = {
    path: "/projects/list",
    method: "GET"
}
/**
 * AI会话添加
 */
export const addAiSession = {
    path: "/projects/add",
    method: "POST"
}
/**
 * AI会话修改
 */
export const updateAiSession = {
    path: "/projects/edit",
    method: "POST"
}
/**
 * AI会话删除
 */
export const deleteAiSession = {
    path: "/projects/delete",
    method: "GET"
}

/**
 * 会话详情
 */
export const getAiSessionDetail = {
    path: "/agent-projects-step/list",
    method: "GET"
}
/**
 * 添加会话详情
 */
export const addAiSessionStep = {
    path: "/agent-projects-step/add",
    method: "POST"
}
/**
 * 修改会话
 */
export const updateAiSessionStep = {
    path: "/agent-projects-step/edit",
    method: "POST"
}
/**
 * 删除会话详情
 */
export const deleteAiSessionStep = {
    path: "/agent-projects-step/remove",
    method: "GET"
}
/**
 * AI对话-流式,SSE长连接
 */
export const getAiSessionStepStream = {
    path: "/ai/stream",
    method: "POST"
}

/**
 * 普通输入AI对话
 */
export const getAiSessionStep = {
    path: "/ai/generateText",
    method: "POST"
}
/**
 * 获取AI对话提示词模板
 */
export const getAiSessionStepTemplate = {
    path: "/ai/promptDetail",
    method: "GET"
}
/**
 * 获取OSS上传凭证
 */
export const getOssUploadCredential = {
    path: "/ai/getAliyunSts",
    method: "GET"
}
/**
 * AI生图
 */
export const generateImage = {
    path: "/ai/generateImage",
    method: "POST"
}
/**
 * AI生图任务查询，入参taskId
 */
export const getImageTasks = {
    path: "/ai/imageTasks",
    method: "GET"
}
/**
 * AI生视频
 */
export const generateVideo = {
    path: "/ai/generateVideo",
    method: "POST"
}
/**
 * AI生视频任务查询，入参taskId
 */
export const getVideoTasks = {
    path: "/ai/tasksVideo",
    method: "GET"
}
/**
 * AI生视频结果查询，入参aiTaskId
 */
export const getVideoTaskResult = {
    path: "/ai/tasks",
    method: "GET"
}

/**
 * 灵感广场 - 获取二级分类列表
 */
export const getInspirationCategoryList = {
    path: "/inspiration/category/list",
    method: "GET"
}
/**
 * 灵感广场 - 查询素材列表
 * 入参：categoryType(1图片 2视频 3模板 4文案)、categoryIds(逗号分隔)、pageNum、pageSize
 */
export const getInspirationList = {
    path: "/inspiration/list",
    method: "GET"
}
/**
 * 灵感广场 - 查询素材详情
 * 入参：id
 */
export const getInspirationDetail = {
    path: "/inspiration/detail",
    method: "GET"
}



// WEBPACK FOOTER //
// ./src/api/home.js